import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useArticle } from '../../hooks/useArticles';

/**
 * Composant de redirection SEO pour les anciens liens avec ID
 * Redirige automatiquement vers l'URL avec slug
 */
const ArticleRedirect = () => {
  const { id } = useParams();
  const { article, loading, error } = useArticle(id);

  // Redirection 301 vers l'URL avec slug
  useEffect(() => {
    if (article && article.slug) {
      // Remplacer l'URL dans l'historique pour un redirect 301 SEO-friendly
      window.history.replaceState(null, '', `/article/${article.slug}`);
    }
  }, [article]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '16px',
        color: '#666'
      }}>
        Redirection en cours...
      </div>
    );
  }

  if (error || !article) {
    return <Navigate to="/actualites" replace />;
  }

  if (article.slug) {
    return <Navigate to={`/article/${article.slug}`} replace />;
  }

  // Si pas de slug, utiliser l'ID (fallback)
  return <Navigate to={`/article/${article.id}`} replace />;
};

export default ArticleRedirect;
